import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Status from 'client/components/aria/Status/Status';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import styles from './OptIn.module.scss';

const OptIn = ({ children, as = 'fieldset', ...props }) => {
    const Component = as;
    return <Component
        {...props}
        className={[styles.wrapper, props.className].filter(Boolean).join(' ')}
        data-testid={props['data-testid'] ? props['data-testid'] : null}
    >
        {children}
    </Component>;
};

const Header = ({ children, className }) => (
    <legend className={[styles.title, className].filter(Boolean).join(' ')}>
        <span className={styles.status}>
            <Status variant='blue'>
                <FormattedMessage id='optIn.betaFeature' />
            </Status>
        </span>
        {children}
    </legend>
);

const Description = ({ children, className }) => <p className={['govuk-body', className].filter(Boolean).join(' ')}>{children}</p>;

const Option = ({ id, name, value, checked, onChange, children }) => (
    <div className={[styles.visualRadioItem, 'govuk-radios__item'].join(' ')}>
        <input
            className="govuk-radios__input"
            id={id}
            data-testid={id}
            name={name}
            type="radio"
            value={value}
            checked={checked}
            onChange={onChange}
        />
        <label
            className={[styles.visualRadioLabel, 'govuk-label govuk-radios__label'].join(' ')}
            htmlFor={id}
            data-testid={`${id}-label`}
        >
            {children}
        </label>
    </div>
);

OptIn.Header = Header;
OptIn.Description = Description;
OptIn.Option = Option;

OptIn.propTypes = {
    ...defaultAriaProps,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    'data-testid': PropTypes.string,
    as: PropTypes.oneOf(['fieldset', 'section'])
};

OptIn.defaultProps = {
    className: null,
    'data-testid': null
};

Header.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};

Description.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};

Option.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired
};

Option.defaultProps = {
    checked: false
};

export default OptIn;
